import * as React from "react"

import HeaderNavigation from "./header-navigation"
import HeaderRegistration from "./header-registration"

type Props = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}

const Header: React.FC<Props> = ({ utmSource, utmMedium, utmCampaign, utmContent }) => (
  <div>
    <div className="lg:hidden">
      <HeaderRegistration
        utmSource={utmSource}
        utmMedium={utmMedium}
        utmCampaign={utmCampaign}
        utmContent={utmContent}
      />
    </div>
    <header className="shadow-md">
      <HeaderNavigation
        utmSource={utmSource}
        utmMedium={utmMedium}
        utmCampaign={utmCampaign}
        utmContent={utmContent}
      />
    </header>
  </div>
)

export default Header
